var _excluded = ["children", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'clsx';
var defaultProps = {
  className: 'react-tabs__tab-list'
};
var propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
} : {};

var TabList = function TabList(props) {
  var children = props.children,
      className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React.createElement("ul", _extends({}, attributes, {
    className: cx(className),
    role: "tablist"
  }), children);
};

TabList.tabsRole = 'TabList';
TabList.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
TabList.defaultProps = defaultProps;
export default TabList;